export default "__VITE_ASSET__CDt2cZbe__"